(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerWrapper = document.querySelector('.header-wrapper');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always';
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.headerCoords = {};
			this.calcHeaderCoords();

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
		}

		disconnectedCallback() {
			this.removeEventListener(
				'preventHeaderReveal',
				this.hideHeaderOnScrollUp,
			);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		calcHeaderCoords() {
			const clientRect = this.getBoundingClientRect();
			const pageYOffset =
				window.pageYOffset || document.documentElement.scrollTop;
			this.headerCoords.bottom = pageYOffset + clientRect.bottom;
			this.headerCoords.top = pageYOffset + clientRect.top;
		}

		onScroll() {
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky) {
				if (this.header.classList.contains('color-background-overlay')) {
					if (scrollTop > this.header.offsetHeight + 1) {
						this.header.classList.remove('color-background-overlay');
						this.header.classList.add(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}

				if (this.header.classList.contains('color-background-overlay-hidden')) {
					if (scrollTop < this.header.offsetHeight) {
						this.header.classList.add('color-background-overlay');
						this.header.classList.remove(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}
			}

			if (
				scrollTop > this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (
				scrollTop < this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerCoords.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
			);
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');

			if (this.header.classList.contains('color-background-overlay')) {
				this.header.classList.remove('color-background-overlay');
				this.header.classList.add('color-background-overlay-hidden');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			);

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				this.header.classList.add('color-background-overlay');
				this.header.classList.remove('color-background-overlay-hidden');
			}
		}

		closeMenuDisclosure() {
			this.disclosures =
				this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (typeof DetailsDisclosure !== 'undefined') {
				this.disclosures.forEach(disclosure => {
					disclosure.close();
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach(disclosureList => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.spinnerIcon = this.querySelector('.cart__note-loading');
			this.successIcon = this.querySelector('.cart__note-success');
			this.textarea = this.querySelector('textarea');
			this.cartButtons = document.querySelector('.cart__ctas');

			this.textarea.addEventListener(
				'input',
				debounce((event) => {
					this.spinnerIcon.style.display = 'block';
					this.successIcon.style.display = 'none';
					this.cartButtons.style.pointerEvents = 'none';
					this.cartButtons.style.opacity = '0.7';

					const body = JSON.stringify({ note: event.target.value });

					fetch(`${routes.cart_update_url}`, {
						...fetchConfig(),
						...{ body },
					})
						.then((response) => {
							if (!response.ok) {
								throw new Error('Network response was not ok');
							}
							return response.json();
						})
						.then((data) => {
							this.successIcon.style.display = 'block';

							setTimeout(() => {
								this.successIcon.style.display = 'none';
							}, 2000);
						})
						.catch((error) => {
							console.error(
								'There was a problem with the fetch operation:',
								error,
							);
						})
						.finally(() => {
							this.spinnerIcon.style.display = 'none';
							this.cartButtons.removeAttribute('style');
						});
				}, 300),
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mysterious-skin"] && !Shopify.designMode) return;
  try {
    
/* No third-party dependency. Data provider and pure helpers are also testable in Node. */
(function (global) {
  'use strict';
  const normalize = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const clean = value => String(value ?? '').trim();
  function safeUrl(value, base = global.location?.origin || 'https://example.invalid') {
    if (!clean(value)) return '';
    try { const url = new URL(value, base); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  }
  function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
  }
  function todayParis(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const part = key => parts.find(p => p.type === key).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  }
  function coordinates(lat, lng) {
    if (!clean(lat) || !clean(lng)) return null;
    const latitude = Number(lat), longitude = Number(lng);
    return Number.isFinite(latitude) && Math.abs(latitude) <= 90 && Number.isFinite(longitude) && Math.abs(longitude) <= 180 ? { latitude, longitude } : null;
  }
  function distance(a, b) {
    const rad = n => n * Math.PI / 180;
    const h = Math.sin(rad(b.latitude - a.latitude) / 2) ** 2 + Math.cos(rad(a.latitude)) * Math.cos(rad(b.latitude)) * Math.sin(rad(b.longitude - a.longitude) / 2) ** 2;
    return 6371 * 2 * Math.asin(Math.sqrt(Math.min(1, h)));
  }
  function normalizeRows(rows, { hidePast = true, today = todayParis() } = {}) {
    return (Array.isArray(rows) ? rows : []).flatMap((row, index) => {
      if (!row || typeof row !== 'object' || row.enabled === false || !clean(row.cinema) || !validDate(row.date) || (hidePast && row.date < today)) return [];
      const bookingUrl = safeUrl(row.bookingUrl);
      const raw = Array.isArray(row.times) ? row.times : clean(row.times).split(',').map(time => ({ time: time.trim(), url: bookingUrl }));
      const seen = new Set();
      const times = raw.flatMap(item => {
        if (!item || !/^([01]\d|2[0-3]):[0-5]\d$/.test(item.time)) return [];
        const url = safeUrl(item.url || bookingUrl), label = clean(item.label), key = `${item.time}|${url}|${label}`;
        if (seen.has(key)) return [];
        seen.add(key); return [{ time: item.time, label, url }];
      }).sort((a, b) => a.time.localeCompare(b.time));
      return [{ id: clean(row.id) || `row-${index}`, blockId: clean(row.blockId), cinemaId: clean(row.cinemaId) || normalize(`${row.cinema}-${row.city}-${row.address}`), cinema: clean(row.cinema), city: clean(row.city), postalCode: clean(row.postalCode), address: clean(row.address), agreement: clean(row.agreement), date: row.date, dateLabel: clean(row.dateLabel), coords: coordinates(row.latitude, row.longitude), bookingUrl, times }];
    });
  }
  // Manual rows override the same API id, including enabled:false tombstones.
  function mergeRows(api, manual) {
    const rows = new Map();
    [...api, ...manual].forEach((row, index) => { if (row && typeof row === 'object') rows.set(clean(row.id) || `generated-${index}`, row); });
    return [...rows.values()];
  }
  function groupsFor(rows, query = '', cinemaId = '', position = null, radius = null) {
    const terms = normalize(query).split(/\s+/).filter(Boolean), groups = new Map();
    rows.filter(row => (!cinemaId || row.cinemaId === cinemaId) && terms.every(term => normalize(`${row.city} ${row.postalCode} ${row.cinema}`).includes(term))).forEach(row => {
      if (!groups.has(row.cinemaId)) groups.set(row.cinemaId, { ...row, rows: [], distance: null });
      const group = groups.get(row.cinemaId);
      group.rows.push(row); if (!group.coords && row.coords) group.coords = row.coords;
    });
    const min = Math.max(0, Number(radius?.min || 0));
    const max = Math.max(min, Number(radius?.max || 0));
    return [...groups.values()].map(group => {
      group.rows.sort((a, b) => a.date.localeCompare(b.date) || (a.times[0]?.time || '').localeCompare(b.times[0]?.time || ''));
      group.distance = position && group.coords ? distance(position, group.coords) : null;
      return group;
    }).filter(group => !position || !max || (group.distance !== null && group.distance >= min && group.distance <= max))
      .sort((a, b) => position ? (a.distance ?? Infinity) - (b.distance ?? Infinity) || a.cinema.localeCompare(b.cinema, 'fr') : a.city.localeCompare(b.city, 'fr') || a.cinema.localeCompare(b.cinema, 'fr'));
  }
  const api = { normalize, safeUrl, validDate, todayParis, coordinates, distance, normalizeRows, mergeRows, groupsFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  if (global.MysteriousSkin) return;
  global.MysteriousSkin = Object.freeze(api);
  const instances = new WeakMap();
  const dateLabel = value => new Intl.DateTimeFormat('fr-FR', { dateStyle: 'full', timeZone: 'Europe/Paris' }).format(new Date(`${value}T12:00:00Z`));
  function el(tag, className, text) {
    const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node;
  }
  function trackingAllowed(root) {
    return root.dataset.msTracking === 'true' && !global.Shopify?.designMode && global.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }
  function track(root, event, extra = {}) {
    if (!trackingAllowed(root)) return;
    // No search text, URL parameters, exact address or GPS in payloads.
    const payload = { event: `Mysteriousskin_${event}`, film: 'Mysterious_skin', release_status: root.dataset.msStatus, ...extra };
    root.dispatchEvent(new CustomEvent('Mysteriousskin:analytics', { bubbles: true, detail: payload }));
    // Consumer/CMP owns analytics transport. There is deliberately no automatic dataLayer push.
  }
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController(), { signal } = controller;
    const state = { controller, observer: null, position: null, cityPosition: null, geoRequest: 0, showAll: false };
    instances.set(root, state);
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-ms-event]');
      if (link && root.contains(link)) track(root, link.dataset.msEvent, { placement: link.dataset.msPlacement || '', cinema_id: link.dataset.msCinema || '' });
    }, { signal });
    root.querySelectorAll('[data-ms-shop]').forEach(link => {
      const safe = safeUrl(link.getAttribute('href')); if (!safe) return;
      const url = new URL(safe);
      for (const [key, value] of Object.entries({ utm_source: 'Mysteriousskin', utm_medium: 'referral', utm_campaign: link.dataset.campaign, utm_content: 'poster' })) if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
      link.href = url.href;
    });
    root.querySelectorAll('[data-ms-play]').forEach(button => button.addEventListener('click', () => {
      const wrap = button.closest('[data-ms-video]'), id = wrap.dataset.msVideo;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
      const frame = el('iframe'); frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      frame.title = wrap.dataset.title; frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true; frame.referrerPolicy = 'strict-origin-when-cross-origin';
      wrap.replaceChildren(frame); frame.focus(); track(root, 'trailer_load', { placement: 'trailer' });
    }, { signal }));
    const poster = root.querySelector('[data-ms-poster]');
    if (poster && 'IntersectionObserver' in global) {
      state.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && trackingAllowed(root)) { track(root, 'poster_view', { placement: 'poster' }); state.observer.disconnect(); }
      }, { threshold: 0.2 }); state.observer.observe(poster);
    }
    const moduleNode = root.querySelector('[data-ms-sessions]');
    if (moduleNode) initSessions(root, moduleNode, state, signal);
  }
  async function initSessions(root, node, state, signal) {
    let manual, imported = [], releasePlan = [];
    try { manual = JSON.parse(node.querySelector('[data-ms-screenings]').textContent); } catch { return; }
    try { imported = JSON.parse(node.querySelector('[data-ms-imported-screenings]')?.textContent || '[]'); } catch { imported = []; }
    try { releasePlan = JSON.parse(node.querySelector('[data-ms-release-plan]')?.textContent || '[]'); } catch { releasePlan = []; }
    const options = { hidePast: node.dataset.hidePast === 'true' };
    const radius = { min: Number(node.dataset.radiusMin || 0), max: Number(node.dataset.radiusMax || 50) };
    let rows = normalizeRows(mergeRows(releasePlan, mergeRows(imported, manual)), options), query = '', cinemaId = '', sourceFailure = false;
    const form = node.querySelector('[data-ms-search]'), input = form.elements.city, radiusInput = form.elements.radius, radiusLabel = node.querySelector('[data-ms-radius-label]'), suggestions = node.querySelector('[data-ms-suggestions]'), results = node.querySelector('[data-ms-results]'), status = node.querySelector('[data-ms-result-status]'), geoStatus = node.querySelector('[data-ms-geo-status]'), map = node.querySelector('[data-ms-map]'), geoButton = node.querySelector('[data-ms-use-position]');
    const params = new URLSearchParams(global.location.search); query = params.get('city') || ''; cinemaId = params.get('cinema') || ''; input.value = query;
    const initialRadius = Number(params.get('radius') || radiusInput?.value || radius.max);
    if (Number.isFinite(initialRadius)) radius.max = Math.max(5, Math.min(100, initialRadius));
    if (radiusInput) radiusInput.value = String(radius.max);
    if (radiusLabel) radiusLabel.textContent = `${radius.max} km`;
    function updateUrl() {
      const url = new URL(global.location.href);
      query ? url.searchParams.set('city', query) : url.searchParams.delete('city');
      cinemaId ? url.searchParams.set('cinema', cinemaId) : url.searchParams.delete('cinema');
      query && radius.max ? url.searchParams.set('radius', String(radius.max)) : url.searchParams.delete('radius');
      global.history.replaceState(null, '', url);
    }
    async function geocodeCity(value) {
      const term = clean(value);
      if (!term) return null;
      const localMatch = rows.find(row => normalize(row.city) === normalize(term) && row.coords) || rows.find(row => normalize(row.city).includes(normalize(term)) && row.coords);
      if (localMatch?.coords) return localMatch.coords;
      const url = new URL('https://api-adresse.data.gouv.fr/search/');
      url.searchParams.set('q', term);
      url.searchParams.set('limit', '1');
      try {
        const response = await global.fetch(url.href, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const data = await response.json();
        const coords = data?.features?.[0]?.geometry?.coordinates;
        return Array.isArray(coords) ? coordinates(coords[1], coords[0]) : null;
      } catch { return null; }
    }
    function suggestionButton(label, coords = null) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ms-suggestion';
      button.textContent = label;
      button.dataset.value = label;
      if (coords) {
        button.dataset.latitude = String(coords.latitude);
        button.dataset.longitude = String(coords.longitude);
      }
      return button;
    }
    async function updateAddressSuggestions(value) {
      if (!suggestions) return;
      const term = clean(value);
      if (term.length < 2) { suggestions.hidden = true; suggestions.replaceChildren(); return; }
      const localSeen = new Set();
      const localButtons = [];
      rows.forEach(row => {
        [row.city, row.cinema].forEach(candidate => {
          const label = clean(candidate);
          const key = normalize(label);
          if (!label || localSeen.has(key) || !key.includes(normalize(term))) return;
          localSeen.add(key);
          localButtons.push(suggestionButton(label));
        });
      });
      suggestions.replaceChildren(...localButtons.slice(0, 6));
      suggestions.hidden = !suggestions.children.length;
      const url = new URL('https://api-adresse.data.gouv.fr/search/');
      url.searchParams.set('q', term);
      url.searchParams.set('limit', '6');
      try {
        const response = await global.fetch(url.href, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const seen = new Set(localButtons.map(button => normalize(button.dataset.value)));
        const remoteButtons = (data?.features || []).flatMap(feature => {
          const label = clean(feature?.properties?.label || feature?.properties?.name);
          const raw = feature?.geometry?.coordinates;
          const coords = Array.isArray(raw) ? coordinates(raw[1], raw[0]) : null;
          const key = normalize(label);
          if (!label || !coords || seen.has(key)) return [];
          seen.add(key);
          return [suggestionButton(label, coords)];
        });
        suggestions.replaceChildren(...[...localButtons, ...remoteButtons].slice(0, 12));
        suggestions.hidden = !suggestions.children.length;
      } catch {}
    }
    function updateSummary(groups, shouldShowResults) {
      if (!shouldShowResults) { status.textContent = ''; return; }
      const cityCount = new Set(groups.map(group => normalize(group.city)).filter(Boolean)).size;
      const screeningCount = groups.reduce((total, group) => total + group.rows.length, 0);
      status.textContent = `${groups.length} cinéma${groups.length > 1 ? 's' : ''} trouvé${groups.length > 1 ? 's' : ''} · ${cityCount} ville${cityCount > 1 ? 's' : ''} · ${screeningCount} séance${screeningCount > 1 ? 's' : ''}`;
    }
    function showMap(group) {
      if (!map || !group.coords) return;
      const { latitude: lat, longitude: lng } = group.coords;
      const url = new URL('https://www.openstreetmap.org/export/embed.html');
      url.searchParams.set('bbox', [Math.max(-180, lng - .025), Math.max(-90, lat - .015), Math.min(180, lng + .025), Math.min(90, lat + .015)].join(','));
      url.searchParams.set('layer', 'mapnik'); url.searchParams.set('marker', `${lat},${lng}`);
      const frame = el('iframe'); frame.src = url.href; frame.title = `Carte — ${group.cinema}`; frame.loading = 'lazy'; frame.referrerPolicy = 'no-referrer';
      const link = el('a', '', 'Ouvrir la carte OpenStreetMap'); link.href = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=15/${lat}/${lng}`;
      map.replaceChildren(el('h3', '', group.cinema), frame, link); map.hidden = false; map.tabIndex = -1; map.focus({ preventScroll: true });
      if (global.matchMedia('(max-width: 999px)').matches) map.scrollIntoView({ block: 'nearest' });
      track(root, 'map_open', { cinema_id: group.cinemaId });
    }
    function render() {
      if (signal.aborted) return;
      const searchPosition = state.position || state.cityPosition;
      const shouldShowResults = Boolean(query || cinemaId || searchPosition || state.showAll);
      const groups = state.showAll
        ? groupsFor(rows, '', '', null, null)
        : shouldShowResults
          ? groupsFor(rows, query && state.cityPosition ? '' : query, cinemaId, searchPosition, searchPosition ? radius : null)
          : [];
      results.replaceChildren();
      if (!shouldShowResults)
        results.append(el('p', 'ms-results-prompt', 'Indiquez une ville ou un code postal pour afficher les cinémas.'));
      if (map) { map.hidden = true; map.replaceChildren(); }
      updateSummary(groups, shouldShowResults);
      groups.forEach(group => {
        const article = el('article', 'ms-cinema'); article.dataset.cinemaId = group.cinemaId;
        if (global.Shopify?.designMode && group.blockId) article.dataset.shopifyEditorBlock = JSON.stringify({ id: group.blockId, type: 'screening' });
        article.append(el('h3', '', group.cinema), el('p', '', [group.address, [group.postalCode, group.city].filter(Boolean).join(' ')].filter(Boolean).join(' — ')));
        group.rows.forEach(row => {
          if (row.agreement) article.append(el('p', '', row.agreement));
          article.append(el('p', '', `Date de la séance : ${row.dateLabel || dateLabel(row.date)}`));
          const url = row.bookingUrl || row.times.find(slot => slot.url)?.url;
          if (url) {
            const link = el('a', 'ms-button', 'Billetterie');
            link.href = url; link.dataset.msEvent = 'booking_click'; link.dataset.msCinema = group.cinemaId; link.dataset.msPlacement = 'sessions';
            link.setAttribute('aria-label', `Billetterie ${group.cinema}, ${row.dateLabel || dateLabel(row.date)}`); article.append(link);
          } else article.append(el('p', 'ms-booking', 'Billetterie à venir'));
        });
        results.append(article);
      });
    }
    node.querySelector('[data-ms-controls]').hidden = false;
    async function runTextSearch() {
      query = input.value.trim(); cinemaId = ''; state.position = null; state.cityPosition = null; state.showAll = false;
      if (query && input.dataset.latitude && input.dataset.longitude) state.cityPosition = coordinates(input.dataset.latitude, input.dataset.longitude);
      else if (query) state.cityPosition = await geocodeCity(query);
      render(); updateUrl();
      if (query) track(root, 'sessions_search', { method: 'text', result_count: groupsFor(rows, '', '', state.cityPosition, radius).length });
    }
    let searchTimer = 0;
    form.addEventListener('submit', event => { event.preventDefault(); runTextSearch(); }, { signal });
    input.addEventListener('input', () => {
      global.clearTimeout(searchTimer);
      delete input.dataset.latitude; delete input.dataset.longitude;
      updateAddressSuggestions(input.value);
      searchTimer = global.setTimeout(runTextSearch, 350);
    }, { signal });

    suggestions?.addEventListener('click', event => {
      const button = event.target.closest('.ms-suggestion');
      if (!button) return;
      input.value = button.dataset.value || button.textContent || '';
      if (button.dataset.latitude && button.dataset.longitude) {
        input.dataset.latitude = button.dataset.latitude;
        input.dataset.longitude = button.dataset.longitude;
      } else {
        delete input.dataset.latitude; delete input.dataset.longitude;
      }
      suggestions.hidden = true; suggestions.replaceChildren();
      runTextSearch();
    }, { signal });
    document.addEventListener('click', event => {
      if (!node.contains(event.target)) { suggestions.hidden = true; }
    }, { signal });
    radiusInput?.addEventListener('input', () => {
      radius.max = Number(radiusInput.value || radius.max);
      if (radiusLabel) radiusLabel.textContent = `${radius.max} km`;
      if (query || state.cityPosition || state.position) { render(); updateUrl(); }
    }, { signal });
    geoButton?.addEventListener('click', () => {
      const geolocation = global.navigator?.geolocation;
      if (!global.isSecureContext) {
        geoStatus.textContent = 'La géolocalisation fonctionne uniquement sur une page sécurisée HTTPS. Utilisez la recherche ville ou code postal.';
        return;
      }
      if (!geolocation) {
        geoStatus.textContent = 'La géolocalisation n’est pas disponible sur ce navigateur. Utilisez la recherche ville ou code postal.';
        return;
      }
      geoButton.disabled = true;
      geoStatus.textContent = 'Autorisez la localisation dans votre navigateur pour afficher les cinémas proches de vous.';
      geolocation.getCurrentPosition(position => {
        const coords = coordinates(position.coords.latitude, position.coords.longitude);
        if (!coords) {
          geoStatus.textContent = 'Position reçue invalide. Utilisez la recherche ville ou code postal.';
          geoButton.disabled = false;
          return;
        }
        state.position = coords;
        state.cityPosition = null;
        state.showAll = false;
        query = '';
        cinemaId = '';
        input.value = '';
        geoStatus.textContent = '';
        render();
        updateUrl();
        track(root, 'sessions_search', { method: 'geolocation', result_count: groupsFor(rows, '', '', state.position, radius).length });
        geoButton.disabled = false;
      }, error => {
        const denied = error && error.code === 1;
        geoStatus.textContent = denied
          ? 'Localisation refusée. Vous pouvez saisir une ville ou un code postal à la place.'
          : 'Impossible d’obtenir votre position. Utilisez la recherche ville ou code postal.';
        geoButton.disabled = false;
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
    }, { signal });
    node.querySelector('[data-ms-reset]').addEventListener('click', () => {
      query = ''; cinemaId = ''; input.value = ''; state.position = null; state.cityPosition = null;
      state.geoRequest++; state.showAll = true; geoStatus.textContent = ''; render(); updateUrl();
    }, { signal });
    render();
    if (node.dataset.mode === 'api' && node.dataset.api) {
      const fetchController = new AbortController(); signal.addEventListener('abort', () => fetchController.abort(), { once: true });
      const timeout = global.setTimeout(() => fetchController.abort(), 8000);
      try {
        const endpoint = new URL(node.dataset.api, global.location.origin);
        if (endpoint.origin !== global.location.origin || !['http:', 'https:'].includes(endpoint.protocol)) throw new Error('Same-origin endpoint required');
        const response = await global.fetch(endpoint.href, { signal: fetchController.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('API failed');
        const data = await response.json();
        if (data.version !== 1 || !Array.isArray(data.screenings) || data.screenings.length > 10000) throw new Error('Invalid API contract');
        rows = normalizeRows(mergeRows(data.screenings, mergeRows(releasePlan, mergeRows(imported, manual))), options); render();
      } catch {
        if (!signal.aborted) {
          sourceFailure = true;
          render();
        }
      }
      finally { global.clearTimeout(timeout); }
    }
  }
  function mount(scope = document) { if (scope.matches?.('[data-ms-root]')) init(scope); scope.querySelectorAll('[data-ms-root]').forEach(init); }
  function unmount(scope) { scope.querySelectorAll('[data-ms-root]').forEach(root => { const state = instances.get(root); if (state) { state.controller.abort(); state.observer?.disconnect(); state.position = null; instances.delete(root); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true }); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-ms-root]') || event.target.querySelector?.('[data-ms-root]');
    if (!root) return;
    const selected = [...root.querySelectorAll('[data-shopify-editor-block]')].find(node => { try { return JSON.parse(node.dataset.shopifyEditorBlock).id === event.detail.blockId; } catch { return false; } });
    selected?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})(typeof window !== 'undefined' ? window : globalThis);


  } catch(e) { console.error(e); }
})();
})();
